import { styled } from '@mui/system';
import { Box, Paper, IconButton, Typography } from '@mui/material';
import { colors } from '../../constants/theme';

export const STROKE_COLOR = '#D9CEC7';
export const PLUS_BG = '#fff';

export const FaqPaper = styled(Paper)(({ theme }) => ({
  borderRadius: '24px',
  background: '#fff',
  borderColor: STROKE_COLOR,
  overflow: 'hidden',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  transition: 'all 0.2s ease',
  width: '100%',
  maxWidth: '490px',
  '&:hover': {
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    maxWidth: '100%',
  },
}));

export const QuestionHeader = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingLeft: '30px',
  paddingTop: '20px',
  paddingBottom: '20px',
  paddingRight: '20px',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export const ExpandIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'isExpanded',
})(({ isExpanded }) => ({
  width: '50px',
  height: '50px',
  borderRadius: '20px',
  background: PLUS_BG,
  border: '1px solid',
  borderColor: STROKE_COLOR,
  flexShrink: 0,
  color: colors.text,
  transition: 'transform 0.2s ease',
  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  '&:hover': {
    background: '#f5f5f5',
  },
}));

export const AnswerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  borderTop: '1px solid',
  borderColor: STROKE_COLOR,
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

export const QuestionText = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  margin: '0',
  fontWeight: 700,
  fontFamily: 'Quicksand',
  fontSize: '20px',
  lineHeight: '42px',
  letterSpacing: '.4px',
  [theme.breakpoints.down('md')]: {
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '.4px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

export const AnswerText = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  fontSize: '18px',
  lineHeight: 1.8,
  color: theme.palette.text.secondary,
  [theme.breakpoints.down('md')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));
